<p>
  When player's lifetime net loss reaches one of the values below then SG interaction and a commentary is created.<br />
  The same checkpoint is never triggered twice for the same player.
</p>
<div class="row">
  <div class="row">
    @for (risk of thresholdsByRisk; track risk) {
      <div class="col">
        {{ risk.riskRating }}
        <table class="table">
          @for (threshold of risk.thresholds; track threshold) {
            <tr>
              <td>{{ threshold.value }}</td>
            </tr>
          }
        </table>
      </div>
    }
  </div>
</div>
